import React, {useEffect, useState} from 'react'
import {useParams} from 'react-router-dom'
import {restRequest} from '../../../api-utils/apiQueries'

const MatesDetails = () => {
  const [mates, setMates] = useState<any>([])
  const [favoritesMates, setFavoritesMates] = useState<any>([])
  const [showFavorites, setShowFavorites] = useState<boolean>(false)
  const params = useParams()

  const toggleSwitch = () => {
    setShowFavorites((prevState) => !prevState)
  }

  const fetchMatesData = async () => {
    let response: any = await restRequest.getUserMatesData(params.id)
    let favMates = response.data.data.favourite_mates
    let allMates = response.data.data.list_of_mates
    setMates(allMates)
    setFavoritesMates(favMates)
  }

  useEffect(() => {
    fetchMatesData()
  }, [params])

  return (
    <div>
      {/* <div className='card card-xxl-stretch mb-5 mb-xl-10'>
        <div className='card-header border-0 pt-5'>
          <div className='d-flex align-items-center justify-content-between w-full'>
            <p className='card-title fw-bold text-dark'> Mates Of User</p>
            <p className='text-gray-700 mt-3 fw-semibold fs-3 text-end border align-items-end ms-15'>
              {showFavorites ? favoritesMates.length : mates.length}
            </p>
            <div className='form-check form-switch ms-15 d-flex justify-content-center align-items-center'>
              <input
                className='form-check-input'
                type='checkbox'
                role='switch'
                id='flexSwitchCheckChecked'
                checked={showFavorites}
                onChange={toggleSwitch}
              />
              <label className='form-check-label ms-2 text-gray-600 fs-4 font-semibold'>
                Favorite
              </label>
            </div>
          </div>
        </div>

        <div className='card-body pt-5 mx-5' style={{maxHeight: '350px', overflowY: 'auto'}}>
          {showFavorites
            ? favoritesMates.map((user: any, index: number) => (
                <p className='text-gray-800 fs-6 fw-bold' key={index}>
                  {user.name}
                </p>
              ))
            : mates.map((user: any, index: number) => (
                <p className='text-gray-800 fs-6 fw-bold' key={index}>
                  {user.name}
                </p>
              ))}
        </div>
      </div> */}
      <div className='row gap-5'>
        <div className=' col card card-xxl-stretch mb-5 mb-xl-10'>
          <div className='card-header border-0 pt-5'>
            <div className='d-flex align-items-center justify-content-between w-full'>
              <p className='card-title fw-bold text-dark'>Favorite Mates Of User</p>
              <p className='text-gray-700 mt-3 fw-semibold fs-3 text-end border align-items-end ms-15'>
                {favoritesMates.length}
              </p>
            </div>
          </div>

          <div className='card-body pt-5 mx-5' style={{maxHeight: '350px', overflowY: 'auto'}}>
            {favoritesMates.map((user: any, index: number) => (
              <p className='text-gray-800 fs-6 fw-bold' key={index}>
                {user.name}
              </p>
            ))}
          </div>
        </div>
        <div className=' col card card-xxl-stretch mb-5 mb-xl-10'>
          <div className='card-header border-0 pt-5'>
            <div className='d-flex align-items-center justify-content-between w-full'>
              <p className='card-title fw-bold text-dark'>All Mates Of User</p>
              <p className='text-gray-700 mt-3 fw-semibold fs-3 text-end border align-items-end ms-15'>
                {mates.length}
              </p>
            </div>
          </div>

          <div className='card-body pt-5 mx-5' style={{maxHeight: '350px', overflowY: 'auto'}}>
            {mates.map((user: any, index: number) => (
              <p className='text-gray-800 fs-6 fw-bold' key={index}>
                {user.name}
              </p>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default MatesDetails
